// Reconstructed from production code; original paths and local names were not available.
import { MEDIA_BASE_URL } from "../services/config.js";
import React from "react";
import { Seo } from "../components/Seo.jsx";
import { api } from "../services/api.js";
import * as jsxRuntime from "react/jsx-runtime";
import { useCart } from "../context/CartContext.jsx";
import { useLanguage } from "../context/LanguageContext.jsx";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../context/ThemeContext.jsx";
function deviceToken() {
  if (typeof window > "u") return null;
  let l = localStorage.getItem("device_mac_token");
  l ||
    (window.crypto && window.crypto.randomUUID
      ? (l = window.crypto.randomUUID())
      : (l = Date.now().toString(36) + Math.random().toString(36).slice(2, 10)),
    localStorage.setItem("device_mac_token", l));
  return l;
}
function CheckoutPage() {
  const l = useNavigate(),
    i = useLocation(),
    { theme: theme } = useTheme(),
    { t: t, tProd: tProd, language: language, tText } = useLanguage(),
    {
      items: items,
      total: total,
      cartId: cartId,
      startFreshCart: startFreshCart,
      updateItemQuantity: updateItemQuantity,
    } = useCart(),
    x = language === "ar",
    O = new URLSearchParams(i.search).get("quote") === "1",
    [H, E] = React.useState(""),
    [M, N] = React.useState({
      first_name: "",
      last_name: "",
      email: "",
      phone: "",
      address: "",
      location: "",
      message: "",
    }),
    [T, Y] = React.useState(false),
    [$, I] = React.useState(""),
    [K, J] = React.useState(""),
    [Q, W] = React.useState({}),
    te = React.useRef(null);
  React.useEffect(() => {
    const A = deviceToken();
    A && E(A);
  }, []);
  React.useEffect(() => {
    W((A) => {
      const X = {};
      items.forEach((q) => {
        X[q.id] = A[q.id] ?? String(q.quantity || 1);
      });
      return X;
    });
  }, [items]);
  const oe = (A, X) => {
      N((q) => ({
        ...q,
        [A]: X,
      }));
    },
    he = async (A) => {
      if ((A.preventDefault(), I(""), J(""), !items.length)) {
        I(t("cartEmpty"));
        return;
      }
      if (!cartId) {
        I(tText("No cart found. Please try again."));
        return;
      }
      try {
        if ((Y(true), fe))
          for (const Z of items) {
            const ee = Math.max(1, Number.parseInt(Q[Z.id], 10) || 1);
            ee !== Number(Z.quantity || 0) &&
              (await updateItemQuantity(Z.id, ee));
          }
        const X = {
            ...M,
            wantQuote: fe,
            deviceToken: H,
            cartId: cartId,
          },
          q = await api.post("/commandes", X);
        J(q.data?.message || t("orderSuccess"));
        try {
          await startFreshCart();
        } catch (Z) {
          console.warn("Could not prepare a fresh cart", Z);
        }
        setTimeout(() => {
          l("/");
        }, 4e3);
      } catch (X) {
        console.error(X);
        I(X.response?.data?.message || t("orderError"));
      } finally {
        Y(false);
      }
    },
    be = theme?.site_name || "MyShop",
    fe = O,
    pe = t(T ? "sendingOrder" : fe ? "sendQuoteRequest" : "sendOrder"),
    ye = (A) => Math.max(1, Number.parseInt(Q[A.id], 10) || 1),
    R = fe
      ? items.find((A) => A.min_order_devis > 0 && ye(A) < A.min_order_devis)
      : null,
    B = items.find((A) => A.out_of_stock),
    F = T || !items.length || !!R || !!B;
  React.useEffect(() => {
    K &&
      (window.scrollTo({
        top: 0,
        behavior: "smooth",
      }),
      te.current?.focus({
        preventScroll: true,
      }));
  }, [K]);
  const re = t(fe ? "checkoutSuccessQuoteTitle" : "checkoutSuccessOrderTitle"),
    ge = t(fe ? "checkoutSuccessQuoteText" : "checkoutSuccessOrderText"),
    j = async (A) => {
      const X = Math.max(1, Number.parseInt(Q[A.id], 10) || 1);
      if (
        (W((q) => ({
          ...q,
          [A.id]: String(X),
        })),
        X !== Number(A.quantity || 0))
      )
        try {
          await updateItemQuantity(A.id, X);
        } catch (q) {
          I(q.response?.data?.message || t("orderError"));
        }
    };
  return (
    <div className={"page checkout-page"}>
      <Seo
        title={t("checkoutTitle")}
        description={tText("Finalize your order securely.")}
        image={theme?.logo || null}
        urlPath={i.pathname}
        type={"website"}
        siteName={be}
        noindex={true}
      />
      <div className={"checkout-container"}>
        {K ? (
          <section
            ref={te}
            className={"checkout-success-card"}
            role={"status"}
            aria-live={"polite"}
            tabIndex={-1}
          >
            <span className={"checkout-success-icon"} aria-hidden={"true"}>
              {"✓"}
            </span>
            <span className={"checkout-success-kicker"}>
              {t(fe ? "requestDevis" : "checkoutTitle")}
            </span>
            <h1>{re}</h1>
            <p>{ge}</p>
            <p className={"checkout-success-next"}>
              {t("checkoutSuccessNext")}
            </p>
            <button
              type={"button"}
              className={"checkout-success-home"}
              onClick={() => l("/")}
            >
              {t("checkoutSuccessBackHome")}
            </button>
          </section>
        ) : (
          <jsxRuntime.Fragment>
            <section className={"checkout-form-card"}>
              <h1 className={"checkout-title"}>{t("checkoutTitle")}</h1>
              <p className={"checkout-subtitle"}>{t("checkoutSubtitle")}</p>
              {$ && (
                <div className={"checkout-alert-error"} role={"alert"}>
                  {tText($)}
                </div>
              )}
              <form
                id={"checkout-form"}
                className={"checkout-form"}
                onSubmit={he}
              >
                <div className={"checkout-grid-2"}>
                  <label className={"checkout-field"}>
                    {t("firstName")}
                    {" *"}
                    <input
                      type={"text"}
                      placeholder={x ? "مثال: محمد" : "e.g. John"}
                      value={M.first_name}
                      onChange={(A) => oe("first_name", A.target.value)}
                      autoComplete={"given-name"}
                      autoCapitalize={"words"}
                      enterKeyHint={"next"}
                      required={true}
                    />
                  </label>
                  <label className={"checkout-field"}>
                    {t("lastName")}
                    {" *"}
                    <input
                      type={"text"}
                      placeholder={x ? "مثال: بن علي" : "e.g. Smith"}
                      value={M.last_name}
                      onChange={(A) => oe("last_name", A.target.value)}
                      autoComplete={"family-name"}
                      autoCapitalize={"words"}
                      enterKeyHint={"next"}
                      required={true}
                    />
                  </label>
                </div>
                <div className={"checkout-grid-2"}>
                  <label className={"checkout-field"}>
                    {t("email")}
                    {" *"}
                    <input
                      type={"email"}
                      placeholder={"name@example.com"}
                      value={M.email}
                      onChange={(A) => oe("email", A.target.value)}
                      autoComplete={"email"}
                      autoCapitalize={"none"}
                      inputMode={"email"}
                      enterKeyHint={"next"}
                      spellCheck={"false"}
                      required={true}
                    />
                  </label>
                  <label className={"checkout-field"}>
                    {t("phone")}
                    {" *"}
                    <input
                      type={"tel"}
                      placeholder={x ? "مثال: 99 000 000" : "e.g. 99 000 000"}
                      value={M.phone}
                      onChange={(A) => oe("phone", A.target.value)}
                      autoComplete={"tel"}
                      inputMode={"tel"}
                      enterKeyHint={"next"}
                      required={true}
                    />
                  </label>
                </div>
                <label className={"checkout-field"}>
                  {t("city")}
                  {" *"}
                  <input
                    type={"text"}
                    placeholder={x ? "مثال: تونس" : "e.g. Tunis"}
                    value={M.location}
                    onChange={(A) => oe("location", A.target.value)}
                    autoComplete={"address-level2"}
                    autoCapitalize={"words"}
                    enterKeyHint={"next"}
                    required={true}
                  />
                </label>
                <label className={"checkout-field"}>
                  {t("address")}
                  {" *"}
                  <textarea
                    rows={2}
                    placeholder={
                      x
                        ? "اكتب العنوان بالتفصيل"
                        : "Enter your full delivery address"
                    }
                    value={M.address}
                    onChange={(A) => oe("address", A.target.value)}
                    autoComplete={"street-address"}
                    enterKeyHint={"next"}
                    required={true}
                  />
                </label>
                {O && (
                  <div className={"checkout-quote-flow-note"} role={"status"}>
                    {t("quoteFlowNote")}
                  </div>
                )}
                {R && (
                  <div className={"checkout-validation-message"} role={"alert"}>
                    {language === "ar"
                      ? `لطلب عرض سعر، يجب أن تطلب على الأقل ${R.min_order_devis} قطعة من "${tProd(R.product_name)}".`
                      : `For a quote request, please enter at least ${R.min_order_devis} items of "${tProd(R.product_name)}".`}
                  </div>
                )}
                {B && (
                  <div className={"checkout-validation-message"} role={"alert"}>
                    {language === "ar"
                      ? `المنتج "${tProd(B.product_name)}" غير متوفر حالياً. يمكنك حفظه في السلة، لكن لا يمكن إرسال الطلب قبل عودة المخزون.`
                      : `"${tProd(B.product_name)}" is currently unavailable. You can keep it in your cart, but the order cannot be sent until it is back in stock.`}
                  </div>
                )}
                {fe && (
                  <label
                    className={
                      "checkout-field checkout-quote-details is-enabled"
                    }
                  >
                    {t("devisDetails")}
                    <textarea
                      rows={3}
                      placeholder={t("devisDetailsPlaceholder")}
                      value={M.message}
                      onChange={(A) => oe("message", A.target.value)}
                      enterKeyHint={"done"}
                    />
                  </label>
                )}
                <button
                  type={"submit"}
                  className={"checkout-submit-btn checkout-submit-btn--form"}
                  disabled={F}
                >
                  {pe}
                </button>
              </form>
            </section>
            <aside
              className={"checkout-summary-card"}
              aria-label={t("orderSummary")}
            >
              <h2>{t("orderSummary")}</h2>
              {items.length === 0 ? (
                <p className={"checkout-muted"}>{t("cartEmpty")}</p>
              ) : (
                <jsxRuntime.Fragment>
                  <ul className={"checkout-items-list"}>
                    {items.map((A) => {
                      const X = A.variant_image_url || A.product_image_url,
                        q = X
                          ? X.startsWith("http")
                            ? X
                            : `${MEDIA_BASE_URL}${X}`
                          : null,
                        Z = A.line_total || A.unit_price * A.quantity;
                      return (
                        <li className={"checkout-item"} key={A.id}>
                          {q && (
                            <img
                              src={q}
                              alt={tProd(A.product_name)}
                              className={"checkout-item-img"}
                            />
                          )}
                          <div className={"checkout-item-main"}>
                            <div className={"checkout-item-top"}>
                              <span className={"checkout-item-title"}>
                                {tProd(A.product_name)}
                              </span>
                              {!fe && (
                                <span className={"checkout-item-price"}>
                                  {Z.toFixed(2)}
                                  {" OMR"}
                                </span>
                              )}
                            </div>
                            <div className={"checkout-item-bottom"}>
                              {A.variant_name && (
                                <span className={"checkout-item-variant"}>
                                  {tProd(A.variant_name)}
                                </span>
                              )}
                              {fe ? (
                                <label className={"checkout-quote-qty"}>
                                  <span>
                                    {language === "ar" ? "الكمية" : tText("Quantity")}
                                  </span>
                                  <input
                                    type={"number"}
                                    min={"1"}
                                    inputMode={"numeric"}
                                    aria-label={`${language === "ar" ? "الكمية" : tText("Quantity")} ${tProd(A.product_name)}`}
                                    value={Q[A.id] ?? A.quantity}
                                    onChange={(ee) =>
                                      W((ie) => ({
                                        ...ie,
                                        [A.id]: ee.target.value,
                                      }))
                                    }
                                    onBlur={() => j(A)}
                                  />
                                </label>
                              ) : (
                                <span className={"checkout-item-qty"}>
                                  {"x"}
                                  {A.quantity}
                                </span>
                              )}
                            </div>
                          </div>
                        </li>
                      );
                    })}
                  </ul>
                  <div className={"checkout-summary-footer"}>
                    {fe ? (
                      <div className={"checkout-quote-summary"}>
                        <strong>
                          {language === "ar" ? "طلب عرض سعر" : "Quote request"}
                        </strong>
                        <span>
                          {language === "ar"
                            ? "أدخل الكميات المطلوبة. السعر يحدده المسؤول ويرسله لك لاحقاً."
                            : "Enter the quantities you need. The administrator will set and send the price."}
                          <br />
                          <small>
                            {x
                              ? "سيصلك عبر البريد الإلكتروني سعر القطعة والمجموع النهائي."
                              : "The email will show the price per piece and the final total."}
                          </small>
                        </span>
                      </div>
                    ) : (
                      <jsxRuntime.Fragment>
                        <div className={"checkout-summary-row"}>
                          <span>{t("subtotal")}</span>
                          <span>
                            {total.toFixed(2)}
                            {" OMR"}
                          </span>
                        </div>
                        <div
                          className={
                            "checkout-summary-row checkout-summary-row-muted"
                          }
                        >
                          <span>{t("shipping")}</span>
                          <span>{t("calculatedLater")}</span>
                        </div>
                        <div
                          className={
                            "checkout-summary-row checkout-summary-row-strong"
                          }
                        >
                          <span>{t("total")}</span>
                          <span>
                            {total.toFixed(2)}
                            {" OMR"}
                          </span>
                        </div>
                      </jsxRuntime.Fragment>
                    )}
                  </div>
                </jsxRuntime.Fragment>
              )}
            </aside>
          </jsxRuntime.Fragment>
        )}
      </div>
      {!K && (
        <div
          className={"checkout-mobile-submit-bar"}
          aria-label={t("checkoutTitle")}
        >
          <div className={"checkout-mobile-submit-bar__summary"}>
            <span>{t(fe ? "requestDevis" : "total")}</span>
            <strong>
              {fe ? t("requestDevis") : `${total.toFixed(2)} OMR`}
            </strong>
          </div>
          <button
            type={"submit"}
            form={"checkout-form"}
            className={"checkout-submit-btn"}
            disabled={F}
          >
            {pe}
          </button>
        </div>
      )}
    </div>
  );
}
export { deviceToken, CheckoutPage };
